import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

interface PropsType {
    langKey: string;
    defaultText: string;
    params?: Record<string, string | number>;
}

export const I18n = observer('I18n', (props: PropsType): JSX.Element | null => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const { langKey, defaultText, params } = props;

    return <>{languagesState.getTranslation(langKey, defaultText, params)}</>;
});
